import React from 'react';
import Pin from 'Modules/Shared/icons/pin';

const PinIcon = () => {
  return <Pin width={24} height={24} fill={'rgb(114, 114, 114)'} />;
};

export default PinIcon;
